import {
  ProductImageData,
  ProductImages,
} from '../../../collaborators/fetch-products/new-contract/types';

const buildKeyValueList = (
  data: ProductImageData[]
): Record<string, string> => {
  let keyValueList: Record<string, string> = {};
  data.forEach((image) => {
    keyValueList = { ...keyValueList, [image.type]: image.path };
  });
  return keyValueList;
};

const createImagesObj = (
  fieldMap: Record<string, string>,
  imageList: Record<string, string>
) => {
  let images: Record<string, string> = {};
  Object.keys(fieldMap).forEach((key: string) => {
    // TODO: this is a mock value
    const value =
      imageList[key] ||
      'https://www.gap.com/webcontent/0019/077/401/cn19077401.jpg';
    const newKey = fieldMap[key];
    images = { ...images, [newKey]: value };
  });
  return images;
};

const productImagesAdapter = (data: ProductImageData[]): ProductImages => {
  const avImagesFieldMap: Record<string, string> = {
    AV1_QL: 'av1QuicklookImagePath',
    AV2_QL: 'av2QuicklookImagePath',
    AV3_QL: 'av3QuicklookImagePath',
    AV4_QL: 'av4QuicklookImagePath',
    AV5_QL: 'av5QuicklookImagePath',
    AV6_QL: 'av6QuicklookImagePath',
    AV9_QL: 'av9QuicklookImagePath',
    P01: 'p1QuicklookImagePath',
  };
  const zoomImagesFieldMap: Record<string, string> = {
    Z: 'p01ZoomImagePath',
    AV1_Z: 'av1ZoomImagePath',
  };
  const pristineImagesFieldMap: Record<string, string> = {
    PRST_IMG: 'pristine1ImagePath',
  };
  const otherImagesFieldMap: Record<string, string> = {
    VI_ONESITE: 'categoryLargeImage',
    QL: 'quicklookImage',
    S: 'colorSwatchImage',
  };

  const originalImageList = buildKeyValueList(data);
  const avImages = createImagesObj(avImagesFieldMap, originalImageList);
  const zoomImages = createImagesObj(zoomImagesFieldMap, originalImageList);
  const pristineImages = createImagesObj(
    pristineImagesFieldMap,
    originalImageList
  );
  const otherImages = createImagesObj(otherImagesFieldMap, originalImageList);

  return {
    avImages,
    zoomImages,
    pristineImages,
    otherImages,
  } as ProductImages;
};

export default productImagesAdapter;
